import type { ApiPagedCollectionResposne, ListProduct } from "~/types"

const MAX_ITEMS = 10

const saveToLocalStorage = (ids: number[]) => {
  if (import.meta.client) {
    localStorage.setItem('recentlyViewed', JSON.stringify(ids.slice(0, MAX_ITEMS)))
  }
}

const getFromLocalStorage = (): number[] => {
  if (import.meta.client) {
    return JSON.parse(localStorage.getItem('recentlyViewed') || '[]')
  }
  return []
}

type RecentlyViewedProductsOptions = {
  autoload?: boolean
}

export function useRecentlyViewedProducts(options :  RecentlyViewedProductsOptions = {}) {
  const recentlyViewed = ref<number[]>([])

  if (import.meta.client) {
    recentlyViewed.value = getFromLocalStorage()
  }

  const addProduct = (id: number) => {
    let viewed = recentlyViewed.value.filter(pid => pid !== id)
    viewed.unshift(id)
    saveToLocalStorage(viewed)
  }

  const catalogService = useCatalogService()

  const {
    pending,
    execute,
    data
  } = useAsyncData<ApiPagedCollectionResposne<ListProduct>>(
    () => catalogService.getProducts({ ids: recentlyViewed.value.join(","), perPage: MAX_ITEMS }),
    {
      default: () => ({ data: [], meta: { currentPage: 1, total: 0 } }),
      watch: [recentlyViewed],
      server: false,
      immediate: options.autoload !== false,
      transform: (data: ApiPagedCollectionResposne<ListProduct>) => {
        const idOrder = recentlyViewed.value

        data.data.sort((a, b) => {
          return idOrder.indexOf(a.id) - idOrder.indexOf(b.id)
        })

        return data
      }
    }
  )

  watchEffect(() => {
    console.log('Recently viewed products updated:', data.value.data)
  })

  return {
    addProduct,
    pending,
    load: execute,
    data: computed(() => data.value.data || [])
  }
}